import { render, staticRenderFns } from "./SearchInsurance.vue?vue&type=template&id=3c5dda54&scoped=true"
import script from "./SearchInsurance.vue?vue&type=script&lang=js"
export * from "./SearchInsurance.vue?vue&type=script&lang=js"
import style0 from "./SearchInsurance.vue?vue&type=style&index=0&id=3c5dda54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dda54",
  null
  
)

export default component.exports